<!--
  Root template of the ProvisionType object component. Branches on the view mode only — exactly the
  shape of cp-provision-agent-object.component.html and bm-billing-area-object.component.html
  (PAT §L.2). The `initialized && dto` guard is mandatory (rule G3.1): before that there is no dto.
  `handleNavigationItems($event)` forwards the left navigation of the view component to the frame.
-->
@if (initialized && dto) {

    @if (uiMode == 'side' || uiMode == 'mini-side') {

        <cp-provision-type-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></cp-provision-type-side>

    } @else {

        <cp-provision-type-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></cp-provision-type-full>

    }

}
